import LabAccount from "./LabServiceModel/LabAccount"
import { ObservableFromFetch } from "../ObservableFromFetch"
import LabPanel from "../Randoms/RandomsModel/LabPanel";

export interface LabAccountsGetParams {
  AccountID?: number
  CompanyID: number
  RegionID: number
  LocationID: number
  SearchFor: string
  SearchBy: string
  DOT: boolean
  AutoFilter?: string
  IsMarketPlace: boolean
  Link?: string
}

export interface FilteredLabAccountsGetParams {
  AccountID?: number
  CompanyID: number
  RegionID: number
  LocationID: number
  SearchFor: string
  SearchBy: string
  DOT: boolean
  AutoFilter?: string
  IsMarketPlace: boolean
  Link?: string
  POCT: boolean
  Panel: string
}

interface LabLookup {
  DOT: boolean
  LabAccount: string
  Laboratory: string
  Link?: string
}

export default function LabAccountsGetObservable(params: LabAccountsGetParams) {
  const requestBody: string = JSON.stringify({
    ...params
  });

  return ObservableFromFetch<LabAccount[]>("order/GetLabAccounts", requestBody)
}

export function FilteredLabAccountsGetObservable(params: FilteredLabAccountsGetParams) {
  const requestBody: string = JSON.stringify({
    ...params
  });

  return ObservableFromFetch<LabAccount[]>("order/GetFilteredLabAccounts", requestBody)
}

export function LabAccountLookup(account: string, lab: string, dot: boolean, link: string) {
  const params: LabLookup = {
    DOT: dot,
    LabAccount: account,
    Laboratory: lab
  }

  if (link !== "") { params.Link = link }

  const requestBody: string = JSON.stringify(params);

  return ObservableFromFetch<LabPanel[]>("FFOrderUser/GetAccountLookup", requestBody)
}

